require('../modules/core.number.iterator');
module.exports = require('../modules/_core').Number;



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/core/number.js
// module id = 90
// module chunks = 0